import signupTemplate from './bank-info-signup.html';
import accountMobileTemplate from './bank-info-acc-mobile.html';
import accountDesktopTemplate from './bank-info-acc-desktop.html';
import CommonApp from '../../app.js';
import {strings} from '../../../util/strings.js';
import {configManager} from '../../../util/config-manager/config-manager.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager.js';
import {userProfileManager} from '../../../util/user-profile-manager.js';
import {BankInfoService} from '../../services/bank-info-service.js';
import {BankInfoConfigsFactory} from '../../../util/banking/bankInfo-configs.js';

var BankInfoController = function($sce,
    $scope,
    $http,
    $q,
    $uibModal,
    $timeout,
    configManager,
    AccountConfigManager,
    strings) {
    var self = this;
    self.strings = strings;

    self.bankAccountDetails = $sce.trustAsHtml(strings.get('tdc_bankAccountDetails'));
    self.helplineMessage = $sce.trustAsHtml(strings.get('tdc_helplineMessage'));
    self.showFullHelplineMessage = window.innerWidth > 767;
    self.directDepositPolicyPopUp = $sce.trustAsHtml(strings.get('tdc_directDepositPolicyPopUp'));

    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    var countryCode = accountConfigManager.site.countryCode;

    self.bankCheckLinkTitle = strings.get('tdc_bankCheckLinkTitle');
    self.bankCheckTitle = strings.get('tdc_bankCheckTitle');
    self.bankCheckCloseImage = strings.get('bankCheckCloseImage');
    self.bankCheckImage = strings.get('bankCheckImage');

    self.countryCode = countryCode;
    self.width = window.innerWidth;
    self.bankInfo = self.bankInfo || {};
    self.bankFormInfo = self.bankFormInfo || {};
    self.bankInfoConfigs = BankInfoConfigsFactory.getBankInfoConfigs(countryCode).banking;

    self.IBANCountries = BankInfoConfigsFactory.getIbanCountries();
    self.bankInfo.ibanMarketCode = countryCode;

    self.subscribeEventListeners = function() {
        document.getElementById('directDepositCheckbox').addEventListener('change', function() {
            self.bankInfo.acceptedDirectDepositPolicy = this.checked;
            $scope.$apply();
        });
    };

    self.updateDirectDepositPolicyCheckbox = function(checked) {
        if (checked) {
            document.getElementById('directDepositCheckbox').setAttribute('checked', '');
        } else {
            document.getElementById('directDepositCheckbox').removeAttribute('checked');
        }
    };

    // N&: called in init function, this does some simple logic to setup the configurations needed
    var setUpBankInfoConfigs = function() {
        // N&: if the country does not have a direct deposit policy,
        // set the accepted to true so they can save bank info
        if (!self.bankInfoConfigs.directDeposit.show) {
            self.bankInfo.acceptedDirectDepositPolicy = true;
            self.updateDirectDepositPolicyCheckbox(self.bankInfo.acceptedDirectDepositPolicy);
        }

        self.branchNumMaxLength = self.bankInfoConfigs.branchNumber.maxLength;
        // N&: ui-mask does not like maxlength - if there is a ui-mask, set maxlength to undefined
        if (self.bankInfoConfigs.branchNumber && self.bankInfoConfigs.branchNumber.uiMask) {
            self.bankInfoConfigs.branchNumber.maxLength = undefined;
        }
        if (self.bankInfoConfigs.iban) {
            self.getIbanMask(self.countryCode);
        }
    };

    self.retrieveBanks = function() {
        var atlasServiceEndPoint = accountConfigManager.system['atlas_service_url'];
        var config = {
            headers: {
                'content-type': 'application/json'
            }
        };
        var url = atlasServiceEndPoint + 'banks/' + countryCode +'.json';
        $http.get(url, config).then(function(response) {
            if (response.status === 200) {
                self.bankList = response.data.banks;
            }
        });
    };
    if (countryCode === 'CA' || countryCode === 'NZ') {
        self.retrieveBanks();
    }

    self.showMore = false;
    self.formName = self.formName || '';

    self.checkTitle = function() {
        var name = '';
        var userDetails = userProfileManager.getUserProfileDetailInfo();

        if (userDetails && self.bankInfo.accountHolder) {
            name = userDetails['profileHeader']['firstName'].trim();

            if (userDetails['profileHeader']['lastName']) {
                name = name + ' ' + userDetails['profileHeader']['lastName'].trim();
            }

            return (self.bankInfo.accountHolder.toLowerCase() === name.toLowerCase());
        }
        return false;
    };

    // this will remove the modal backdrop if user clicks back button
    self.listenForHashchange = function() {
        window.addEventListener('hashchange', function() {
            $('.modal-backdrop').remove();
        });
    };

    self.directDepositPopup = function() {
        var directDepositModalTemplate = 'directDepositModalTemplate.html';
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            keyboard: false,
            templateUrl: directDepositModalTemplate,
            controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
                var modalSelf = this;
                modalSelf.model = {};

                modalSelf.model.directDepositPolicyPopUp = $sce
                    .trustAsHtml(strings.get('tdc_directDepositPolicyPopUp'));
                modalSelf.ok = function() {
                    $uibModalInstance.close();
                };

                modalSelf.cancel = function() {
                    $uibModalInstance.dismiss();
                };

                $scope.$on('$locationChangeStart', function($event) {
                    $uibModalInstance.dismiss();
                });
            }],
            controllerAs: 'ctrl',
            windowClass: 'app-modal-window direct-deposit-popup business-section-popup'
        });
    };

    self.showBankCheckExmpl = function() {
        $timeout(function() {
            angular.element('.bank-example-hyperlink div h4 a').trigger('click');
        });
    };

    self.checkRoutingNumber = function(currentForm) {
        var isFieldInvalid = self.bankInfo.routingNumber && self.bankInfo.routingNumber.length
            !== self.bankInfoConfigs.routingNumber.maxLength;
        currentForm.routingNumber.$setValidity('fieldInvalid', !isFieldInvalid);
        currentForm.routingNumber.$setValidity('invalidRoutingNumber', true);
    };

    self.checkBranchNumber = function(form) {
        form.branchNumber.$setValidity('inuse', true);
        form.branchNumber.$setValidity('invalidBranchNumber', true);
    };

    self.validateAccNum = function(bankingForm) {
        // N&: if there is an inuse error being shown, this will remove it when the field has focus
        bankingForm.accountNumber.$setValidity('inuse', true);
    };

    /**
     * Method takes bankInfoConfigs, and if the prePopulate.accountNAme property is true, it will take the set name
     * and auto-fill the accountHolder field in DirectDeposit.
     * Manually disables the error which always fails as touched and incomplete since it is programmatically filled.
     * @param {Object} bankInfoConfigs
     */
    var prePopulateValues = function(bankInfoConfigs) {
        if (bankInfoConfigs.prePopulate.accountName) {
            var userDetails = userProfileManager.getUserProfileDetailInfo();

            var name = userDetails['profileHeader']['firstName'].trim();

            if (userDetails['profileHeader']['lastName']) {
                name = name + ' ' + userDetails['profileHeader']['lastName'].trim();
            }

            self.bankInfo.accountHolder = name;
            self.bankFormInfo.isTitleMatch = true;
        }
    };

    self.checkIbanValidity = function() {
        var isFieldValid;
        var ibanValue;
        var currentForm = $scope.bankingForm;
        if (self.bankInfo.IBAN) {
            ibanValue = self.bankInfo.IBAN.replace(/[^a-zA-Z0-9]/g, '').slice(2);
            isFieldValid = ibanValue && ibanValue.length === self.bankInfoConfigs.ibanActualLength;
            if (isFieldValid) {
                var checkIbanValidity = self.isValidIban(self.bankInfo.ibanMarketCode + ibanValue);
                currentForm.iban.$setValidity('invalidIbanNumber', checkIbanValidity);
            } else {
                currentForm.iban.$setValidity('invalidIbanNumber', isFieldValid);
            }
        }
    };

    self.processInput = function() {
        self.clearIbanError();
        var input = self.bankInfo.IBAN;

        if (input && input.length == 2) {
            var code = input.toUpperCase();
            self.formatInput(code, input);
        } else if (input && input.length > 2) {
            var code = input.substring(0, 2).toUpperCase();
            if (!self.bankInfoConfigs.ibanMask || code != self.bankInfo.ibanMarketCode) {
                // Case where the whole IBAN is pasted
                self.formatInput(code, input);
            } else {
                self.formatIban(input);
            }
        }
    };

    self.formatInput = function(code, input) {
        if (self.IBANCountries.indexOf(code) >= 0) {
            self.bankInfo.ibanMarketCode = code;
            self.getIbanMask(code);
            self.formatIban(input);
        } else {
            self.showIbanError();
        }
    };

    self.getIbanMask = function(countryCode) {
        self.bankInfoConfigs = BankInfoConfigsFactory.getBankInfoConfigs(countryCode.toUpperCase()).banking;
        var mask = self.bankInfoConfigs.iban.uiMask;
        if (mask) {
            self.bankInfoConfigs.ibanMask = mask;
            // Add 3 to the length to include a two-letter countryCode and a space for formatting
            self.bankInfo.ibanRequiredLength = mask.length + 3;
            self.bankInfoConfigs.ibanActualLength = mask.match(/([*])/gi).length;
        }
    };

    self.formatIban = function(input) {
        var chunk = [];
        chunk.push(input.substring(0, 2).toUpperCase());
        input = input.replace(/[^a-zA-Z0-9]+/g, '').substring(2);
        var ibanArray = self.bankInfoConfigs.ibanMask.split(' ');
        var split = ibanArray[0].length;

        for (var i = 0, len = input.length, j = 0; i < len; i += split, j++) {
            split = ibanArray[j].length;
            chunk.push(input.substr( i, split ) );
        }
        self.bankInfo.IBAN = chunk.join(' ').toUpperCase();
    };

    self.isValidIban = function(ibanNumber) {
        ibanNumber = ibanNumber.toUpperCase();
        var newIban = ibanNumber.substr(4, ibanNumber.length)+ibanNumber.substr(0, 4);
        var checkMod = '';
        for (var i = 0; i < newIban.length; ++i) {
            if (newIban.charAt(i).match(/[A-Z]/)) {
                checkMod = (checkMod.toString() + (newIban.charCodeAt(i)-55).toString());
            } else {
                checkMod = checkMod.toString() + newIban.charAt(i).toString();
            }
            checkMod = parseInt(checkMod) % 97;
        }
        return checkMod == 1;
    };

    self.showIbanError = function() {
        $scope.bankingForm.iban.$setValidity('ibanMarket', false);
        $scope.bankingForm.iban.$setTouched();
    };

    self.clearIbanError = function() {
        var currentForm = $scope.bankingForm;
        currentForm.iban.$setValidity('ibanMarket', true);
        currentForm.iban.$setUntouched();
    };

    $(window).on('resize.doResize', function() {
        $scope.$apply(function() {
            self.width = window.innerWidth;
        });
    });

    self.openDirectDepositPopup = function() {
        var modal = document.getElementById('directDepositModalTemplate');
        var bodyElement = document.getElementById('page-sign-up');
        modal.style.display = "block";
        modal.style.zIndex = '103';
        bodyElement.style.overflowY = 'hidden';
    };

    var closeButton = document.getElementById('closeDirectDepositModal');
    closeButton.onclick = function() {
        var modal = document.getElementById('directDepositModalTemplate');
        var bodyElement = document.getElementById('page-sign-up');
        modal.style.display = "none";
        bodyElement.style.overflowY = 'auto';
    };

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        var modal = document.getElementById('directDepositModalTemplate');
        var bodyElement = document.getElementById('page-sign-up');
        if (event.target == modal) {
            modal.style.display = "none";
            bodyElement.style.overflowY = 'auto';
        }
    };

    self.setShowMore = function() {
        self.showMore = !self.showMore;
    };

    self.init = function() {
        setUpBankInfoConfigs();
        prePopulateValues(self.bankInfoConfigs);
        var distributorPaymentDetails = BankInfoService($http, $q, configManager, AccountConfigManager).getBankInfoForAccount();
        distributorPaymentDetails.then(function(response) {
            // The response should be in Atlas format whether it came from Atlas or SAP
            if (response.status === 200 && (response.data.accountHolder || response.data.registeredName)) {
                self.bankFormInfo.isPaymentSkipped = false;
                self.bankFormInfo.isPaymentDisabled = true;
                self.bankFormInfo.isTitleMatch = true;
                self.bankInfo = response.data;
                self.bankInfo.accountHolder = response.data.registeredName;
                self.bankInfo.accountNumber = response.data.accountNumber;
                self.bankInfo.accountType = response.data.accountType === 'S' ? 'Savings' : 'Checking';
                self.bankInfo.routingNumber = response.data.routingNumber;
                self.bankInfo.bankName = response.data.bank.number;
                self.bankInfo.bankNameTitle = response.data.bank.name;
                if (response.data.bank.branches) {
                    // if there is a value, remove the uiMask if there is one
                    self.bankInfoConfigs.branchNumber.uiMask = '';
                    self.bankInfo.branchNumber = response.data.bank.branches[0].number;
                    if (countryCode === 'CA') {
                        self.bankInfo.bankNumber = response.data.routingNumber;
                        self.bankInfo.routingNumber = response.data.bank.branches[0].number;
                    }
                } else {
                    // if there is a value, remove the uiMask if there is one
                    self.bankInfoConfigs.branchNumber.uiMask = '';
                    self.bankInfo.branchNumber = response.data.bank.number;
                }
                if (response.bankAccounts) {
                    self.bankInfoConfigs.ibanMask = '';
                    self.bankInfoConfigs.placeHolder = '';
                    self.bankInfo.IBAN = response.bankAccounts.IBAN;
                }
            } else {
                self.bankFormInfo.isPaymentSkipped = true;
            }
        });

        self.subscribeEventListeners();
    };

    self.init();
};

CommonApp.module.service('configManager', function(){
    return configManager;
});

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});

CommonApp.module.service('strings', function() {
    return strings;
});

BankInfoController.$inject = ['$sce',
    '$scope',
    '$http',
    '$q',
    '$uibModal',
    '$timeout',
    'configManager',
    'AccountConfigManager',
    'strings'];

CommonApp.module.component('nsBankInfo', {
    template: function($element, $attrs) {
        var templates = {
            'signup': signupTemplate,
            'accountDesktop': accountDesktopTemplate,
            'accountMobile': accountMobileTemplate

        };

        return templates[$attrs.template];
    },
    bindings: {
        bankInfo: '=',
        bankFormInfo: '=',
        template: '<'
    },
    controller: BankInfoController,
    controllerAs: 'ctrl'
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/bank-info/bank-info.js
// module id = 250
// module chunks = 0